module.exports = __webpack_public_path__ + "img/right-arrow.11da6722.svg";